import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../../services/passwords/forgotpasswordapi";
import { toast } from "react-toastify";
import "../../styles/passwords/ResetPassword.css";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const token = params.get("token");
  const emailFromUrl = params.get("loginId");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  
  useEffect(() => {
    document.body.classList.add("login-page");
    return () => document.body.classList.remove("login-page");
  }, []);

  useEffect(() => {
    if (!token || !emailFromUrl) {
      toast.error("Invalid or expired reset link");
      navigate("/");
    }
  }, [token, emailFromUrl, navigate]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      toast.error("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoading(true);

      const res = await resetPassword({
        token,
        email: emailFromUrl,
        newPassword,
        confirmPassword,
      });

    
      toast.success(res.message || "Password updated successfully");

      setTimeout(() => navigate("/"), 1500);

    } catch (err) {
      const errorMessage =
        err?.message ||
        err?.errorMessage ||
        "Something went wrong. Please try again.";

      toast.error(errorMessage);
      console.error("Reset password error:", err);

    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <div className="spinner"></div>
        </div>
      )}
    <div className="login-wrapper">
      <div className="login-form-container">
        <h2 className="login-title">Update Password</h2>

        <form className="reset-form" onSubmit={handleSubmit}>
        
          <input
            type="text"
            className="reset-input disabled"
            value={emailFromUrl || ""}
            readOnly
          />

          <input
            type="password"
            className="reset-input"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />

          <input
            type="password"
            className="reset-input"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />

          <button
            type="submit"
            className="reset-button"
            disabled={loading}
          >
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      </div>
    </div>
    </>
  );
};

export default ResetPassword;
